import React, { useState, useEffect } from 'react';
import haukeApiService from '../../services/haukeApi';
import { showSuccessToast } from '../../utils/toastUtils';
import '../../assets/css/profil-admin.css';
import ProducerSelector from '../../components/ProducerSelector';



// Umfangreiche Produktkategorien 1:1 aus Products.js übernommen
const customTabsStyles = `
  .custom-tabs {
    display: flex;
    border-bottom: 1px solid #dee2e6;
    gap: 0;
    flex-wrap: wrap;
    overflow-x: auto;
  }
  
  .tab-btn {
    background: none;
    border: none;
    padding: 12px 16px;
    color: #569F39;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    transition: all 0.15s ease;
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
    min-width: 0;
    flex: 0 0 auto;
  }
  
  .tab-btn:hover {
    color: #4a8530;
    border-bottom-color: #4a8530;
  }
  
  .tab-btn.active {
    color: #212529;
    font-weight: 600;
    border-bottom-color: #212529;
  }
  
  .tab-btn i {
    font-size: 16px;
  }
  
  @media (max-width: 992px) {
    .custom-tabs {
      justify-content: flex-start;
    }
    .tab-btn {
      padding: 10px 14px;
      font-size: 13px;
    }
  }
  
  @media (max-width: 768px) {
    .tab-btn i {
      display: none;
    }
    .tab-btn {
      padding: 8px 10px;
      font-size: 12px;
      min-width: 80px;
      justify-content: center;
    }
    .custom-tabs {
      padding: 0 5px;
    }
  }
  
  @media (max-width: 576px) {
    .custom-tabs {
      flex-direction: column;
      border-bottom: none;
    }
    .tab-btn {
      border-bottom: none;
      border-left: 3px solid transparent;
      text-align: left;
      justify-content: flex-start;
      padding: 12px 16px;
      border-radius: 0;
    }
    .tab-btn:hover {
      border-left-color: #4a8530;
      border-bottom-color: transparent;
    }
    .tab-btn.active {
      border-left-color: #212529;
      border-bottom-color: transparent;
      background-color: #f8f9fa;
    }
  }
  
  /* Scroll only inside the Products card body */
  .products-scroll-card {
    display: flex;
    flex-direction: column;
  }
  .products-scroll-card .card-header {
    flex: 0 0 auto;
  }
  .products-scroll-card .card-body {
    flex: 1 1 auto;
    overflow-y: auto;
    max-height: 65vh;
  }
`;
const productCategories = [
  {
    title: 'Obst',
    icon: '🍎',
    products: [
      { id: 'aepfel', label: 'Äpfel' },
      { id: 'alexander_lucas', label: 'Alexander Lucas' },
      { id: 'aprikosen', label: 'Aprikosen' },
      { id: 'aronia', label: 'Aronia' },
      { id: 'birnen', label: 'Birnen' },
      { id: 'blaue_trauben', label: 'Blaue Trauben' },
      { id: 'boskoop', label: 'Boskoop' },
      { id: 'braeburn', label: 'Braeburn' },
      { id: 'brombeeren', label: 'Brombeeren' },
      { id: 'conference', label: 'Conference' },
      { id: 'cox_orange', label: 'Cox Orange' },
      { id: 'cranberries', label: 'Cranberries' },
      { id: 'dörrpflaumen', label: 'Dörrpflaumen' },
      { id: 'elstar', label: 'Elstar' },
      { id: 'erdbeeren', label: 'Erdbeeren' },
      { id: 'feigen', label: 'Feigen' },
      { id: 'gala', label: 'Gala' },
      { id: 'getrocknete_aepfel', label: 'Getrocknete Äpfel' },
      { id: 'getrocknete_birnen', label: 'Getrocknete Birnen' },
      { id: 'goji_beeren', label: 'Goji-Beeren' },
      { id: 'golden_delicious', label: 'Golden Delicious' },
      { id: 'granny_smith', label: 'Granny Smith' },
      { id: 'gute_luise', label: 'Gute Luise' },
      { id: 'heidelbeeren', label: 'Heidelbeeren' },
      { id: 'himbeeren', label: 'Himbeeren' },
      { id: 'holunder', label: 'Holunder' },
      { id: 'johannisbeeren', label: 'Johannisbeeren' },
      { id: 'jonagold', label: 'Jonagold' },
      { id: 'kirschen', label: 'Kirschen' },
      { id: 'kiwi', label: 'Kiwi' },
      { id: 'mirabellen', label: 'Mirabellen' },
      { id: 'nashi', label: 'Nashi-Birne' },
      { id: 'nektarinen', label: 'Nektarinen' },
      { id: 'pfirsiche', label: 'Pfirsiche' },
      { id: 'pflaumen', label: 'Pflaumen' },
      { id: 'physalis', label: 'Physalis' },
      { id: 'preiselbeeren', label: 'Preiselbeeren' },
      { id: 'quitten', label: 'Quitten' },
      { id: 'renekloden', label: 'Renekloden' },
      { id: 'rosinen', label: 'Rosinen' },
      { id: 'rote_johannisbeeren', label: 'Rote Johannisbeeren' },
      { id: 'sauerkirschen', label: 'Sauerkirschen' },
      { id: 'schwarze_johannisbeeren', label: 'Schwarze Johannisbeeren' },
      { id: 'stachelbeeren', label: 'Stachelbeeren' },
      { id: 'süßkirschen', label: 'Süßkirschen' },
      { id: 'tafeltrauben', label: 'Tafeltrauben' },
      { id: 'weintrauben', label: 'Weintrauben' },
      { id: 'weiße_trauben', label: 'Weiße Trauben' },
      { id: 'williams', label: 'Williams Christ' },
      { id: 'zwetschgen', label: 'Zwetschgen' }
    ]
  },
  {
    title: 'Gemüse',
    icon: '🥬',
    products: [
      { id: 'artischocken', label: 'Artischocken' },
      { id: 'asiasalat', label: 'Asiasalat' },
      { id: 'auberginen', label: 'Auberginen' },
      { id: 'babyspinat', label: 'Babyspinat' },
      { id: 'batavia', label: 'Batavia' },
      { id: 'blumenkohl', label: 'Blumenkohl' },
      { id: 'bohnen', label: 'Bohnen' },
      { id: 'brokkoli', label: 'Brokkoli' },
      { id: 'buschbohnen', label: 'Buschbohnen' },
      { id: 'butternut', label: 'Butternut-Kürbis' },
      { id: 'chili', label: 'Chili' },
      { id: 'chinakohl', label: 'Chinakohl' },
      { id: 'cocktailtomaten', label: 'Cocktailtomaten' },
      { id: 'dicke_bohnen', label: 'Dicke Bohnen' },
      { id: 'eichblattsalat', label: 'Eichblattsalat' },
      { id: 'einlegegurken', label: 'Einlegegurken' },
      { id: 'eisbergsalat', label: 'Eisbergsalat' },
      { id: 'endivien', label: 'Endivien' },
      { id: 'erbsen', label: 'Erbsen' },
      { id: 'erbsenschoten', label: 'Erbsenschoten' },
      { id: 'feldsalat', label: 'Feldsalat' },
      { id: 'fenchel', label: 'Fenchel' },
      { id: 'festkochende_kartoffeln', label: 'Festkochende Kartoffeln' },
      { id: 'fleischtomaten', label: 'Fleischtomaten' },
      { id: 'frühkartoffeln', label: 'Frühkartoffeln' },
      { id: 'frühlingszwiebeln', label: 'Frühlingszwiebeln' },
      { id: 'gelbe_bohnen', label: 'Gelbe Bohnen' },
      { id: 'gelbe_paprika', label: 'Gelbe Paprika' },
      { id: 'gelbe_rueben', label: 'Gelbe Rüben' },
      { id: 'gelbe_zucchini', label: 'Gelbe Zucchini' },
      { id: 'gruene_bohnen', label: 'Grüne Bohnen' },
      { id: 'gruene_paprika', label: 'Grüne Paprika' },
      { id: 'gruener_spargel', label: 'Grüner Spargel' },
      { id: 'gruenkohl', label: 'Grünkohl' },
      { id: 'gurken', label: 'Gurken' },
      { id: 'hokkaido', label: 'Hokkaido-Kürbis' },
      { id: 'jalapenos', label: 'Jalapeños' },
      { id: 'kartoffeln', label: 'Kartoffeln' },
      { id: 'kidneybohnen', label: 'Kidneybohnen' },
      { id: 'kirschtomaten', label: 'Kirschtomaten' },
      { id: 'knoblauch', label: 'Knoblauch' },
      { id: 'knollensellerie', label: 'Knollensellerie' },
      { id: 'kohl', label: 'Kohl' },
      { id: 'kohlrabi', label: 'Kohlrabi' },
      { id: 'kopfsalat', label: 'Kopfsalat' },
      { id: 'kuerbis', label: 'Kürbis' },
      { id: 'lauch', label: 'Lauch' },
      { id: 'lollo_biondo', label: 'Lollo Biondo' },
      { id: 'lollo_rosso', label: 'Lollo Rosso' },
      { id: 'mais', label: 'Mais' },
      { id: 'mangold', label: 'Mangold' },
      { id: 'markerbsen', label: 'Markerbsen' },
      { id: 'mehlige_kartoffeln', label: 'Mehlige Kartoffeln' },
      { id: 'moehren', label: 'Möhren' },
      { id: 'muskat_kuerbis', label: 'Muskat-Kürbis' },
      { id: 'pak_choi', label: 'Pak Choi' },
      { id: 'paprika', label: 'Paprika' },
      { id: 'pastinaken', label: 'Pastinaken' },
      { id: 'patisson', label: 'Patisson' },
      { id: 'peperoni', label: 'Peperoni' },
      { id: 'porree', label: 'Porree' },
      { id: 'postelein', label: 'Postelein' },
      { id: 'radicchio', label: 'Radicchio' },
      { id: 'radieschen', label: 'Radieschen' },
      { id: 'rettich', label: 'Rettich' },
      { id: 'rhabarber', label: 'Rhabarber' },
      { id: 'romanesco', label: 'Romanesco' },
      { id: 'rosenkohl', label: 'Rosenkohl' },
      { id: 'rote_beete', label: 'Rote Beete' },
      { id: 'rote_paprika', label: 'Rote Paprika' },
      { id: 'rotkohl', label: 'Rotkohl' },
      { id: 'rucola', label: 'Rucola' },
      { id: 'ruebenmus', label: 'Rübenmus' },
      { id: 'salat', label: 'Salat' },
      { id: 'salatgurken', label: 'Salatgurken' },
      { id: 'schalotten', label: 'Schalotten' },
      { id: 'schlangengurken', label: 'Schlangengurken' },
      { id: 'schwarzer_rettich', label: 'Schwarzer Rettich' },
      { id: 'schwarzwurzel', label: 'Schwarzwurzel' },
      { id: 'sellerie', label: 'Sellerie' },
      { id: 'spargel', label: 'Spargel' },
      { id: 'spinat', label: 'Spinat' },
      { id: 'spitzpaprika', label: 'Spitzpaprika' },
      { id: 'spitzkohl', label: 'Spitzkohl' },
      { id: 'stangenbohnen', label: 'Stangenbohnen' },
      { id: 'staudensellerie', label: 'Staudensellerie' },
      { id: 'strauchtomaten', label: 'Strauchtomaten' },
      { id: 'süßkartoffeln', label: 'Süßkartoffeln' },
      { id: 'tomaten', label: 'Tomaten' },
      { id: 'topinambur', label: 'Topinambur' },
      { id: 'weißer_spargel', label: 'Weißer Spargel' },
      { id: 'weißkohl', label: 'Weißkohl' },
      { id: 'wirsing', label: 'Wirsing' },
      { id: 'zucchini', label: 'Zucchini' },
      { id: 'zuckererbsen', label: 'Zuckererbsen' },
      { id: 'zuckermais', label: 'Zuckermais' },
      { id: 'zwiebeln', label: 'Zwiebeln' }
    ]
  },
  {
    title: 'Milchprodukte',
    icon: '🥛',
    products: [
      { id: 'allgaeuer', label: 'Allgäuer Bergkäse' },
      { id: 'ayran', label: 'Ayran' },
      { id: 'bergkaese', label: 'Bergkäse' },
      { id: 'biomilch', label: 'Bio-Milch' },
      { id: 'bio_joghurt', label: 'Bio-Joghurt' },
      { id: 'brie', label: 'Brie' },
      { id: 'butter', label: 'Butter' },
      { id: 'butterkäse', label: 'Butterkäse' },
      { id: 'buttermilch', label: 'Buttermilch' },
      { id: 'camembert', label: 'Camembert' },
      { id: 'creme_double', label: 'Crème double' },
      { id: 'creme_fraiche', label: 'Crème fraîche' },
      { id: 'dickmilch', label: 'Dickmilch' },
      { id: 'edamer', label: 'Edamer' },
      { id: 'emmentaler', label: 'Emmentaler' },
      { id: 'fettarme_milch', label: 'Fettarme Milch' },
      { id: 'frischkaese', label: 'Frischkäse' },
      { id: 'fruchtjoghurt', label: 'Fruchtjoghurt' },
      { id: 'fruchtquark', label: 'Fruchtquark' },
      { id: 'gorgonzola', label: 'Gorgonzola' },
      { id: 'gouda', label: 'Gouda' },
      { id: 'griechischer_joghurt', label: 'Griechischer Joghurt' },
      { id: 'gruyere', label: 'Gruyère' },
      { id: 'heumilch', label: 'Heumilch' },
      { id: 'huettenkaese', label: 'Hüttenkäse' },
      { id: 'joghurt', label: 'Joghurt' },
      { id: 'kaese', label: 'Käse' },
      { id: 'kefir', label: 'Kefir' },
      { id: 'kochsahne', label: 'Kochsahne' },
      { id: 'kraeuterbutter', label: 'Kräuterbutter' },
      { id: 'leerdammer', label: 'Leerdammer' },
      { id: 'magermilch', label: 'Magermilch' },
      { id: 'magerquark', label: 'Magerquark' },
      { id: 'mascarpone', label: 'Mascarpone' },
      { id: 'milch-abgepackt', label: 'Milch, abgepackt' },
      { id: 'milch-frisch', label: 'Milch, frisch' },
      { id: 'molke', label: 'Molke' },
      { id: 'mozzarella', label: 'Mozzarella' },
      { id: 'naturjoghurt', label: 'Naturjoghurt' },
      { id: 'parmesan', label: 'Parmesan' },
      { id: 'pecorino', label: 'Pecorino' },
      { id: 'quark', label: 'Quark' },
      { id: 'ricotta', label: 'Ricotta' },
      { id: 'rohmilch', label: 'Rohmilch' },
      { id: 'roquefort', label: 'Roquefort' },
      { id: 'sahne', label: 'Sahne' },
      { id: 'sauerrahmbutter', label: 'Sauerrahmbutter' },
      { id: 'saure_sahne', label: 'Saure Sahne' },
      { id: 'schafsmilch', label: 'Schafsmilch' },
      { id: 'schafsjoghurt', label: 'Schafsjoghurt' },
      { id: 'schlagsahne', label: 'Schlagsahne' },
      { id: 'schmand', label: 'Schmand' },
      { id: 'suessrahmbutter', label: 'Süßrahmbutter' },
      { id: 'tilsiter', label: 'Tilsiter' },
      { id: 'trinkjoghurt', label: 'Trinkjoghurt' },
      { id: 'vollmilch', label: 'Vollmilch' },
      { id: 'ziegenmilch', label: 'Ziegenmilch' },
      { id: 'ziegenjoghurt', label: 'Ziegenjoghurt' },
      { id: 'ziegenkaese', label: 'Ziegenkäse' }
    ]
  },
  {
    title: 'Eier & Geflügel',
    icon: '🥚',
    products: [
      { id: 'eier', label: 'Eier' },
      { id: 'ente', label: 'Ente' },
      { id: 'gans', label: 'Gans' },
      { id: 'gefluegel', label: 'Geflügel' },
      { id: 'huhn', label: 'Huhn' },
      { id: 'pute', label: 'Pute' },
      { id: 'wachteleier', label: 'Wachteleier' }
    ]
  },
  {
    title: 'Fleisch & Wurst',
    icon: '🥩',
    products: [
      { id: 'bauchspeck', label: 'Bauchspeck' },
      { id: 'blutwurst', label: 'Blutwurst' },
      { id: 'bockwurst', label: 'Bockwurst' },
      { id: 'bratwurst', label: 'Bratwurst' },
      { id: 'cervelat', label: 'Cervelat' },
      { id: 'chorizo', label: 'Chorizo' },
      { id: 'currywurst', label: 'Currywurst' },
      { id: 'fasanenfleisch', label: 'Fasanenfleisch' },
      { id: 'fleisch', label: 'Fleisch' },
      { id: 'fleischkäse', label: 'Fleischkäse' },
      { id: 'grillwurst', label: 'Grillwurst' },
      { id: 'gulasch', label: 'Gulasch' },
      { id: 'hackbraten', label: 'Hackbraten' },
      { id: 'hasenfleisch', label: 'Hasenfleisch' },
      { id: 'hirschfleisch', label: 'Hirschfleisch' },
      { id: 'kassler', label: 'Kassler' },
      { id: 'kochschinken', label: 'Kochschinken' },
      { id: 'lammfilet', label: 'Lammfilet' },
      { id: 'lammfleisch', label: 'Lammfleisch' },
      { id: 'lammkeule', label: 'Lammkeule' },
      { id: 'lammkoteletts', label: 'Lammkoteletts' },
      { id: 'landjäger', label: 'Landjäger' },
      { id: 'leberwurst', label: 'Leberwurst' },
      { id: 'mettwurst', label: 'Mettwurst' },
      { id: 'milano_salami', label: 'Milano Salami' },
      { id: 'ochsenschwanz', label: 'Ochsenschwanz' },
      { id: 'parmaschinken', label: 'Parmaschinken' },
      { id: 'pastete', label: 'Pastete' },
      { id: 'pfefferbeißer', label: 'Pfefferbeißer' },
      { id: 'presskopf', label: 'Presskopf' },
      { id: 'rehfleisch', label: 'Rehfleisch' },
      { id: 'rindfleisch', label: 'Rindfleisch' },
      { id: 'rinderbrust', label: 'Rinderbrust' },
      { id: 'rinderhack', label: 'Rinderhack' },
      { id: 'rinderleber', label: 'Rinderleber' },
      { id: 'rindersteak', label: 'Rindersteak' },
      { id: 'roastbeef', label: 'Roastbeef' },
      { id: 'rohschinken', label: 'Rohschinken' },
      { id: 'rückenspeck', label: 'Rückenspeck' },
      { id: 'salami', label: 'Salami' },
      { id: 'schinken', label: 'Schinken' },
      { id: 'schweinebauch', label: 'Schweinebauch' },
      { id: 'schweinefilet', label: 'Schweinefilet' },
      { id: 'schweinefleisch', label: 'Schweinefleisch' },
      { id: 'schweinehack', label: 'Schweinehack' },
      { id: 'schweinehaxe', label: 'Schweinehaxe' },
      { id: 'schweinekoteletts', label: 'Schweinekoteletts' },
      { id: 'schweineschnitzel', label: 'Schweineschnitzel' },
      { id: 'schwarzwälder', label: 'Schwarzwälder Schinken' },
      { id: 'speck', label: 'Speck' },
      { id: 'sülze', label: 'Sülze' },
      { id: 'tafelspitz', label: 'Tafelspitz' },
      { id: 'teewurst', label: 'Teewurst' },
      { id: 'ungarische_salami', label: 'Ungarische Salami' },
      { id: 'weißwurst', label: 'Weißwurst' },
      { id: 'wildfleisch', label: 'Wildfleisch' },
      { id: 'wildschwein', label: 'Wildschwein' },
      { id: 'wurst', label: 'Wurst' },
      { id: 'ziegenfleisch', label: 'Ziegenfleisch' }
    ]
  },
  {
    title: 'Fisch',
    icon: '🐟',
    products: [
      { id: 'aal', label: 'Aal' },
      { id: 'bachforelle', label: 'Bachforelle' },
      { id: 'barsch', label: 'Barsch' },
      { id: 'brachse', label: 'Brachse' },
      { id: 'fisch', label: 'Fisch' },
      { id: 'fischburger', label: 'Fischburger' },
      { id: 'fischfilet', label: 'Fischfilet' },
      { id: 'fischpastete', label: 'Fischpastete' },
      { id: 'forelle', label: 'Forelle' },
      { id: 'hecht', label: 'Hecht' },
      { id: 'karpfen', label: 'Karpfen' },
      { id: 'lachs', label: 'Lachs' },
      { id: 'raeucheraal', label: 'Räucheraal' },
      { id: 'raeucherfisch', label: 'Räucherfisch' },
      { id: 'raeucherforelle', label: 'Räucherforelle' },
      { id: 'raeucherlachs', label: 'Räucherlachs' },
      { id: 'regenbogenforelle', label: 'Regenbogenforelle' },
      { id: 'rotauge', label: 'Rotauge' },
      { id: 'saibling', label: 'Saibling' },
      { id: 'schleie', label: 'Schleie' },
      { id: 'wels', label: 'Wels' },
      { id: 'zander', label: 'Zander' }
    ]
  },
  {
    title: 'Honig & Süßwaren',
    icon: '🍯',
    products: [
      { id: 'akazienhonig', label: 'Akazienhonig' },
      { id: 'bienenwachs', label: 'Bienenwachs' },
      { id: 'bienenwachs_kerzen', label: 'Bienenwachskerzen' },
      { id: 'bluetenhonig', label: 'Blütenhonig' },
      { id: 'bluetenpollen', label: 'Blütenpollen' },
      { id: 'cremehonig', label: 'Cremehonig' },
      { id: 'edelkastanien_honig', label: 'Edelkastanienhonig' },
      { id: 'fichten_honig', label: 'Fichtenhonig' },
      { id: 'gelée_royal', label: 'Gelée Royal' },
      { id: 'heidehonig', label: 'Heidehonig' },
      { id: 'honig', label: 'Honig' },
      { id: 'honigessig', label: 'Honigessig' },
      { id: 'honiglikör', label: 'Honiglikör' },
      { id: 'honigsenf', label: 'Honigsenf' },
      { id: 'honigwein', label: 'Honigwein (Met)' },
      { id: 'kastanienhonig', label: 'Kastanienhonig' },
      { id: 'lindenhonig', label: 'Lindenhonig' },
      { id: 'pollen', label: 'Pollen' },
      { id: 'propolis', label: 'Propolis' },
      { id: 'propolis_salbe', label: 'Propolis-Salbe' },
      { id: 'propolis_tropfen', label: 'Propolis-Tropfen' },
      { id: 'rapshonig', label: 'Rapshonig' },
      { id: 'scheibenhonig', label: 'Scheibenhonig' },
      { id: 'sonnenblumenhonig', label: 'Sonnenblumenhonig' },
      { id: 'tannen_honig', label: 'Tannenhonig' },
      { id: 'wabenhonig', label: 'Wabenhonig' },
      { id: 'waldhonig', label: 'Waldhonig' }
    ]
  },
  {
    title: 'Marmelade & Aufstriche',
    icon: '🍓',
    products: [
      { id: 'erdbeermarmelade', label: 'Erdbeermarmelade' },
      { id: 'himbeermarmelade', label: 'Himbeermarmelade' },
      { id: 'brombeermarmelade', label: 'Brombeermarmelade' },
      { id: 'johannisbeermarmelade', label: 'Johannisbeermarmelade' },
      { id: 'apfelmarmelade', label: 'Apfelmarmelade' },
      { id: 'pflaumenmarmelade', label: 'Pflaumenmarmelade' },
      { id: 'kirschmarmelade', label: 'Kirschmarmelade' },
      { id: 'quittengelee', label: 'Quittengelee' },
      { id: 'holundergelee', label: 'Holundergelee' },
      { id: 'rhabarbermarmelade', label: 'Rhabarbermarmelade' },
      { id: 'mirabellenkonfituere', label: 'Mirabellenkonfitüre' },
      { id: 'fruchtaufstrich_gemischt', label: 'Gemischter Fruchtaufstrich' },
      { id: 'nussaufstrich', label: 'Nussaufstrich' },
      { id: 'apfelmus', label: 'Apfelmus' },
      { id: 'birnenkompott', label: 'Birnenkompott' }
    ]
  },
  {
    title: 'Öle & Gewürze',
    icon: '🫒',
    products: [
      { id: 'oele', label: 'Öle' },
      { id: 'olivenoel', label: 'Olivenöl' },
      { id: 'sonnenblumenoel', label: 'Sonnenblumenöl' },
      { id: 'rapsoel', label: 'Rapsöl' },
      { id: 'leinoel', label: 'Leinöl' },
      { id: 'walnussoel', label: 'Walnussöl' },
      { id: 'kuerbiskernoel', label: 'Kürbiskernöl' },
      { id: 'essig', label: 'Essig' },
      { id: 'kraeuter_getrocknet', label: 'Getrocknete Kräuter' },
      { id: 'gewuerzmischungen', label: 'Gewürzmischungen' }
    ]
  },
  {
    title: 'Getreide & Backwaren',
    icon: '🌾',
    products: [
      { id: 'mehl', label: 'Mehl' },
      { id: 'weizenmehl', label: 'Weizenmehl' },
      { id: 'roggenmehl', label: 'Roggenmehl' },
      { id: 'dinkelmehl', label: 'Dinkelmehl' },
      { id: 'hafermehl', label: 'Hafermehl' },
      { id: 'vollkornmehl', label: 'Vollkornmehl' },
      { id: 'getreide', label: 'Getreide' },
      { id: 'haferflocken', label: 'Haferflocken' },
      { id: 'brot-backwaren', label: 'Brot und Backwaren' },
      { id: 'vollkornbrot', label: 'Vollkornbrot' },
      { id: 'bauernbrot', label: 'Bauernbrot' },
      { id: 'roggenbrot', label: 'Roggenbrot' },
      { id: 'broetchen', label: 'Brötchen' },
      { id: 'kuchen', label: 'Kuchen' },
      { id: 'plaetzchen', label: 'Plätzchen' }
    ]
  },
  {
    title: 'Nudeln & Fertiggerichte',
    icon: '🍝',
    products: [
      { id: 'nudeln', label: 'Nudeln' },
      { id: 'eiernudeln', label: 'Eiernudeln' },
      { id: 'vollkornnudeln', label: 'Vollkornnudeln' },
      { id: 'spätzle', label: 'Spätzle' },
      { id: 'fertiggerichte', label: 'Fertiggerichte' },
      { id: 'suppen', label: 'Suppen' },
      { id: 'eintöpfe', label: 'Eintöpfe' },
      { id: 'saucen', label: 'Saucen' },
      { id: 'pestos', label: 'Pestos' }
    ]
  },
  {
    title: 'Eis & Nachspeisen',
    icon: '🍦',
    products: [
      { id: 'eis', label: 'Eis' },
      { id: 'milcheis', label: 'Milcheis' },
      { id: 'fruchteis', label: 'Fruchteis' },
      { id: 'sorbet', label: 'Sorbet' },
      { id: 'nachspeisen', label: 'Nachspeisen und Süßes' },
      { id: 'pudding', label: 'Pudding' },
      { id: 'joghurt_dessert', label: 'Joghurt-Dessert' },
      { id: 'fruchtquark', label: 'Fruchtquark' }
    ]
  },
  {
    title: 'Kräuter',
    icon: '🌿',
    products: [
      { id: 'petersilie', label: 'Petersilie' },
      { id: 'schnittlauch', label: 'Schnittlauch' },
      { id: 'dill', label: 'Dill' },
      { id: 'basilikum', label: 'Basilikum' },
      { id: 'thymian', label: 'Thymian' },
      { id: 'rosmarin', label: 'Rosmarin' },
      { id: 'oregano', label: 'Oregano' },
      { id: 'salbei', label: 'Salbei' },
      { id: 'majoran', label: 'Majoran' },
      { id: 'liebstöckel', label: 'Liebstöckel' },
      { id: 'estragon', label: 'Estragon' },
      { id: 'kerbel', label: 'Kerbel' },
      { id: 'kresse', label: 'Kresse' },
      { id: 'minze', label: 'Minze' },
      { id: 'melisse', label: 'Melisse' }
    ]
  },
  {
    title: 'Nüsse',
    icon: '🥜',
    products: [
      // Schalenfrüchte
      { id: 'walnuesse', label: 'Walnüsse' },
      { id: 'haselnuesse', label: 'Haselnüsse' },
      { id: 'mandeln', label: 'Mandeln' },
      { id: 'suesse_mandeln', label: 'Süße Mandeln' },
      { id: 'bittermandeln', label: 'Bittermandeln' },
      { id: 'mandelkerne', label: 'Mandelkerne' },
      { id: 'paranüsse', label: 'Paranüsse' },
      { id: 'pekannüsse', label: 'Pekannüsse' },
      { id: 'macadamianüsse', label: 'Macadamianüsse' },
      { id: 'cashewkerne', label: 'Cashewkerne' },
      { id: 'pistazien', label: 'Pistazien' },
      { id: 'erdnüsse', label: 'Erdnüsse' },
      { id: 'pinienkerne', label: 'Pinienkerne' },
      { id: 'kokosnüsse', label: 'Kokosnüsse' },
      { id: 'sonnenblumenkerne', label: 'Sonnenblumenkerne' },
      { id: 'kürbiskerne', label: 'Kürbiskerne' },
      { id: 'sesam', label: 'Sesam' },
      { id: 'leinsamen', label: 'Leinsamen' },
      { id: 'chiasamen', label: 'Chiasamen' },
      { id: 'mohnsamen', label: 'Mohnsamen' },
      
      // Kastanien & Eicheln
      { id: 'maronen', label: 'Maronen' },
      { id: 'esskastanien', label: 'Esskastanien' },
      { id: 'edelkastanien', label: 'Edelkastanien' },
      { id: 'kastanienmehl', label: 'Kastanienmehl' },
      { id: 'eicheln', label: 'Eicheln' },
      
      // Nussprodukte
      { id: 'nussmehl', label: 'Nussmehl' },
      { id: 'mandelmehl', label: 'Mandelmehl' },
      { id: 'haselnussmehl', label: 'Haselnussmehl' },
      { id: 'nussmus', label: 'Nussmus' },
      { id: 'mandelmus', label: 'Mandelmus' },
      { id: 'haselnussmus', label: 'Haselnussmus' },
      { id: 'erdnussbutter', label: 'Erdnussbutter' },
      { id: 'nussöl', label: 'Nussöl' },
      { id: 'walnussöl_extra', label: 'Walnussöl' },
      { id: 'haselnussöl', label: 'Haselnussöl' },
      
      // Gemischte Nüsse
      { id: 'nussmischung', label: 'Nussmischung' },
      { id: 'studentenfutter', label: 'Studentenfutter' },
      { id: 'trail_mix', label: 'Trail Mix' },
      { id: 'geröstete_nüsse', label: 'Geröstete Nüsse' },
      { id: 'gesalzene_nüsse', label: 'Gesalzene Nüsse' }
    ]
  },
  {
    title: 'Getränke',
    icon: '🍷',
    products: [
      { id: 'wein', label: 'Wein' },
      { id: 'rotwein', label: 'Rotwein' },
      { id: 'weißwein', label: 'Weißwein' },
      { id: 'rosé', label: 'Rosé' },
      { id: 'sekt', label: 'Sekt' },
      { id: 'bier', label: 'Bier' },
      { id: 'weißbier', label: 'Weißbier' },
      { id: 'pils', label: 'Pils' },
      { id: 'saft', label: 'Saft' },
      { id: 'apfelsaft', label: 'Apfelsaft' },
      { id: 'birnensaft', label: 'Birnensaft' },
      { id: 'traubensaft', label: 'Traubensaft' },
      { id: 'holundersaft', label: 'Holundersaft' },
      { id: 'getraenke', label: 'Verschiedene Getränke' },
      { id: 'limonade', label: 'Limonade' },
      { id: 'mineralwasser', label: 'Mineralwasser' },
      { id: 'tee', label: 'Tee' },
      { id: 'kraeutertee', label: 'Kräutertee' }
    ]
  }
];

const Produkte = ({ hofId }) => {
  // State
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  // Vereinheitlichte Auswahl (wie Products.js)
  const [selectedProducts, setSelectedProducts] = useState({ own: [] });
  const [externalBySupplier, setExternalBySupplier] = useState({});
  const [activeSupplier, setActiveSupplier] = useState(null); // { producer_id, producer_name, producer_city }
  const [supplierMeta, setSupplierMeta] = useState({}); // hofId -> { producer_name, producer_city }

  // State für Kategorie Expand/Collapse
  const [expandedCategories, setExpandedCategories] = useState({});
  
  // Suche via ProducerSelector (keine lokalen Such-States nötig)

  useEffect(() => {
    loadData();
  }, [hofId]);



  // Hilfsfunktion: categoryProductMap zu selectedProducts konvertieren
  const convertCategoryMapToProductIds = (categoryProductMap) => {
    const productIds = [];
    
    if (!categoryProductMap || typeof categoryProductMap !== 'object') {
      return [];
    }
    
    // Durch alle Kategorien der Map iterieren
    Object.entries(categoryProductMap).forEach(([categoryTitle, productNames]) => {
      if (!Array.isArray(productNames)) return;
      
      // Finde die entsprechende Kategorie in unserer Definition
      const category = productCategories.find(cat => cat.title === categoryTitle);
      if (!category) return;
      
      // Für jeden Produktnamen die entsprechende ID finden
      productNames.forEach(productName => {
        const product = category.products.find(p => p.label === productName);
        if (product && !productIds.includes(product.id)) {
          productIds.push(product.id);
        }
      });
    });
    
    return productIds;
  };

  // Kategorie Toggle
  const toggleCategory = (categoryTitle) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryTitle]: !prev[categoryTitle]
    }));
  };

  // Produkt Toggle (Eigene vs aktiver Lieferant)
  const handleProductToggle = (productId) => {
    if (!activeSupplier || !activeSupplier.producer_id) {
    setSelectedProducts(prev => {
        const currentProducts = Array.isArray(prev.own) ? prev.own : [];
      return {
        ...prev,
          own: currentProducts.includes(productId)
          ? currentProducts.filter(p => p !== productId)
          : [...currentProducts, productId]
      };
      });
      return;
    }
    const supplierId = activeSupplier.producer_id;
    setExternalBySupplier(prev => {
      const list = Array.isArray(prev[supplierId]) ? prev[supplierId] : [];
      const nextList = list.includes(productId)
        ? list.filter(p => p !== productId)
        : [...list, productId];
      return { ...prev, [supplierId]: nextList };
    });
  };

  // Speichern (vereinheitlicht)
  const handleSaveUnified = async () => {
    try {
      setSaving(true);

      // Vereinheitlichte Map: hofId -> Kategorie -> [Produktname]
      const categoryProductMap = {};

      // Eigene Herstellung unter hofId ablegen
      const ownSelectedProducts = Array.isArray(selectedProducts.own) ? selectedProducts.own : [];
      const ownCatMap = {};
      productCategories.forEach(category => {
        const labels = category.products
          .filter(p => ownSelectedProducts.includes(p.id))
          .map(p => p.label);
        if (labels.length > 0) ownCatMap[category.title] = labels;
      });
      if (Object.keys(ownCatMap).length > 0) {
        categoryProductMap[hofId] = ownCatMap;
      }

      // Fremdprodukte je Lieferant
      Object.entries(externalBySupplier).forEach(([supplierId, productIds]) => {
        if (!supplierId || supplierId.startsWith('_')) return;
        const catMap = {};
      productCategories.forEach(category => {
          const labels = category.products
            .filter(p => Array.isArray(productIds) && productIds.includes(p.id))
            .map(p => p.label);
          if (labels.length > 0) catMap[category.title] = labels;
        });
        if (Object.keys(catMap).length > 0) {
          categoryProductMap[supplierId] = catMap;
        }
      });

      // Gesamtanzahl
      const totalExternalCount = Object.values(externalBySupplier)
        .reduce((sum, arr) => sum + (Array.isArray(arr) ? arr.length : 0), 0);
      const totalProductCount = ownSelectedProducts.length + totalExternalCount;

      await haukeApiService.updateDirekterzeuger(hofId, {
        categoryProductMap,
        products: totalProductCount,
        lastEdited: Date.now()
      });

      showSuccessToast('Produkte erfolgreich gespeichert!');
      
    } catch (error) {
      console.error('Error saving products:', error);
      setError('Fehler beim Speichern der Produkte: ' + error.message);
    } finally {
      setSaving(false);
    }
  };

  // Reset (vereinheitlicht)
  const handleResetUnified = () => {
    if (!data) return;
    const unified = data.categoryProductMap;
    const nextExternal = {};
    let nextOwn = [];
    if (unified && typeof unified === 'object') {
      const values = Object.values(unified);
      const isFlat = values.length > 0 && Array.isArray(values[0]);
      if (isFlat) {
        nextOwn = convertCategoryMapToProductIds(unified);
      } else {
        Object.entries(unified).forEach(([id, catMap]) => {
          const ids = convertCategoryMapToProductIds(catMap);
          if (id === hofId) nextOwn = ids; else nextExternal[id] = ids;
        });
      }
    }
    setSelectedProducts({ own: nextOwn });
    setExternalBySupplier(nextExternal);
  };

  const loadData = async () => {
    try {
      setLoading(true);
      
      // Bestehende Daten laden
      const response = await haukeApiService.getDirekterzeugerDetails(hofId);
      const doc = response.data;
      setData(doc);

      // Vereinheitlichtes Laden aus categoryProductMap
      const nextExternalBySupplier = {};
      const nextSupplierMeta = {};
      let nextOwn = [];
      const unified = doc?.categoryProductMap;
      if (unified && typeof unified === 'object') {
        const values = Object.values(unified);
        const isFlat = values.length > 0 && Array.isArray(values[0]);
        if (isFlat) {
          nextOwn = convertCategoryMapToProductIds(unified);
        } else {
          for (const [id, catMap] of Object.entries(unified)) {
            const productIds = convertCategoryMapToProductIds(catMap);
            if (id === hofId) {
              nextOwn = productIds;
            } else {
              nextExternalBySupplier[id] = productIds;
            }
          }

          // Lieferanten-Metadaten laden (Name/Stadt)
          try {
            await Promise.all(
              Object.keys(nextExternalBySupplier).map(async (id) => {
                try {
                  const r = await haukeApiService.getDirekterzeugerDetails(id);
                  const meta = r?.data || r;
                  const name = meta?.name || meta?.producer_name || '';
                  const city = meta?.city || meta?.producer_city || '';
                  nextSupplierMeta[id] = { producer_name: name || id, producer_city: city || '' };
                } catch (_) {
                  nextSupplierMeta[id] = { producer_name: id, producer_city: '' };
                }
              })
            );
          } catch (_) {}
        }
      }
      setSelectedProducts({ own: nextOwn });
      setExternalBySupplier(nextExternalBySupplier);
      setSupplierMeta(nextSupplierMeta);
      
    } catch (err) {
      console.error('Error loading data:', err);
      setError('Fehler beim Laden der Daten');
    } finally {
      setLoading(false);
    }
  };

  // Suche via ProducerSelector – keine lokale handleSearch nötig



  if (loading) return <div className="webling-loading">Daten werden geladen...</div>;
  if (error) return <div className="webling-error">{error}</div>;
  if (!data) return <div className="webling-error">Keine Daten verfügbar</div>;

  return (
    <div className="webling-container" style={{ maxWidth: '100%' }}>
      <div className="webling-content">
        <style dangerouslySetInnerHTML={{ __html: customTabsStyles }} />




        
      



      {/* Vereinheitlichte Produktauswahl wie Products.js */}
      <div className="form-section">
        <style>{`
          .products-scroll-card { display:flex; flex-direction:column; }
          .products-scroll-card .card-header { flex:0 0 auto; }
          .products-scroll-card .card-body { flex:1 1 auto; overflow-y:auto; max-height:65vh; }
        `}</style>

        <div className="row">
          <div className="col-sm-12">
            <div className="d-flex justify-content-end mb-3">
          <button 
                type="button"
                className="btn btn-outline-secondary me-2"
                onClick={handleResetUnified}
                disabled={saving}
              >
                <i className="ti ti-refresh me-1"></i>
                Zurücksetzen
          </button>
                  <button 
                type="button"
                className={`btn btn-primary`}
                onClick={handleSaveUnified}
                disabled={saving}
              >
                <i className="ti ti-device-floppy me-1"></i>
                {saving ? 'Speichert...' : 'Änderungen speichern'}
                  </button>
            </div>
          </div>
                </div>
                
        <div className="row">
          <div className="col-sm-12">
            <div className="card products-scroll-card">
              <div className="card-header pb-0">
                <h5 className="mb-0">Produkte verwalten</h5>
              </div>
              <div className="card-body">
            {/* Ziel-Hof Auswahl */}
            <div className="mb-4">
              <div className="card">
                <div className="card-header">
                  <h5 className="mb-0">Ziel-Hof auswählen</h5>
                </div>
                <div className="card-body">
                  <div className="row g-2 align-items-start mb-3">
                    <div className="col-12 col-md-5 d-flex align-items-center">
        <button 
               type="button"
                        className={`btn btn-sm ${!activeSupplier ? 'btn-primary' : 'btn-outline-success'}`}
                        onClick={() => setActiveSupplier(null)}
                        disabled={saving}
                        title="Eigene Herstellung"
                      >
                        <i className="ti ti-leaf me-1"></i>
                        Eigene Herstellung
                        <span className="ms-2 badge rounded-pill bg-light text-dark">{Array.isArray(selectedProducts.own) ? selectedProducts.own.length : 0}</span>
        </button>
                    </div>
                    <div className="col-12 col-md-7">
                      <ProducerSelector
                        selectedProducer={activeSupplier || {}}
                        onProducerSelect={(producer) => {
                          setActiveSupplier(producer?.producer_id ? producer : null);
                          if (producer?.producer_id) {
                            setSupplierMeta(prev => ({
                              ...prev,
                              [producer.producer_id]: { producer_name: producer.producer_name, producer_city: producer.producer_city }
                            }));
                            setExternalBySupplier(prev => ({
                              ...prev,
                              [producer.producer_id]: Array.isArray(prev[producer.producer_id]) ? prev[producer.producer_id] : []
                            }));
                          }
                        }}
                        currentFarmId={hofId}
                        resultsInFlow={true}
                        className="mb-0"
                      />
      </div>
                  </div>

                  {Object.keys(externalBySupplier).length > 0 && (
                    <div className="mt-2">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <h6 className="mb-0">Externe Lieferanten</h6>
                        <small className="text-muted">Klicken zum Bearbeiten</small>
                      </div>
                      <div className="d-flex flex-wrap gap-2">
                        {Object.keys(externalBySupplier).map(id => {
                          const meta = supplierMeta[id] || { producer_name: id, producer_city: '' };
                          const isActive = activeSupplier && activeSupplier.producer_id === id;
                          return (
                <button 
                              key={id}
                  type="button" 
                              className={`btn btn-sm ${isActive ? 'btn-primary' : 'btn-outline-success'}`}
                              onClick={() => setActiveSupplier({ producer_id: id, producer_name: meta.producer_name, producer_city: meta.producer_city })}
               disabled={saving}
                              title={meta.producer_city || ''}
             >
                              <span className="text-truncate d-inline-block" style={{ maxWidth: '180px' }}>{meta.producer_name || id}</span>
                              <span className="ms-2 badge rounded-pill bg-light text-dark">{(externalBySupplier[id] || []).length}</span>
             </button>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
                    </div>
                    </div>
                    
                 {/* Produktkategorien */}
         <div className="tab-content">
           {productCategories.map(category => {
                const targetList = (!activeSupplier || !activeSupplier.producer_id)
                  ? (Array.isArray(selectedProducts.own) ? selectedProducts.own : [])
                  : (Array.isArray(externalBySupplier[activeSupplier.producer_id]) ? externalBySupplier[activeSupplier.producer_id] : []);
                const selectedCount = category.products.reduce((cnt, p) => cnt + (targetList.includes(p.id) ? 1 : 0), 0);
                const isExpanded = !!expandedCategories[category.title];
             return (
                  <div key={category.title} className="card mb-4">
                    <div
                      className="card-header d-flex justify-content-between align-items-center"
                   onClick={() => toggleCategory(category.title)}
                      role="button"
                      style={{ cursor: 'pointer' }}
                      aria-expanded={isExpanded}
                    >
                      <h5 className="mb-0 d-flex align-items-center">
                     <span className="me-2" style={{ fontSize: '1.2em' }}>{category.icon}</span>
                     {category.title}
                        <span className="ms-2 badge rounded-pill bg-secondary">{selectedCount}</span>
                   </h5>
                      <i className="material-icons">{isExpanded ? 'expand_less' : 'expand_more'}</i>
                    </div>
                 {isExpanded && (
                      <div id={`cat-body-${category.title}`} className="card-body">
                     <div className="row">
                       {category.products.map(product => (
                         <div key={product.id} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                                  id={`product-${(activeSupplier && activeSupplier.producer_id) ? activeSupplier.producer_id : 'own'}-${product.id}`}
                                  checked={
                                    (!activeSupplier || !activeSupplier.producer_id)
                                      ? Array.isArray(selectedProducts.own) && selectedProducts.own.includes(product.id)
                                      : Array.isArray(externalBySupplier[activeSupplier.producer_id]) && externalBySupplier[activeSupplier.producer_id].includes(product.id)
                                  }
                               onChange={() => handleProductToggle(product.id)}
                               disabled={saving}
                             />
                                <label className="form-check-label" htmlFor={`product-${(activeSupplier && activeSupplier.producer_id) ? activeSupplier.producer_id : 'own'}-${product.id}`}>
                               {product.label}
                          </label>
                        </div>
                        </div>
                       ))}
                        </div>
                      </div>
                 )}
                    </div>
             );
           })}
                </div>
            </div>
                  </div>
                </div>
            </div>
          </div>

      </div>

      <div className="webling-footer">
        <button 
          onClick={() => window.history.back()}
          disabled={saving}
          className="cancel-button"
        >
          Schließen
        </button>
          </div>




    </div>
  );
};

export default Produkte; 